import React , {useState, useEffect, useRef} from 'react'
import { styled } from "@mui/material/styles";
import { makeStyles } from "@material-ui/core";
import { Tree, Input, Button, Dropdown, Menu } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

const useStyles = makeStyles({
	treeBox: {
		width: '33.3333%',
		marginBottom: '20px',
		'@media screen and (max-width: 1200px)' : {
			width: '50%'
		},
		'& .ant-tree-treenode': {
			'& .ant-tree-node-content-wrapper': {
				flex: '1',
				paddingRight: '0 !important'
			}
		},
		'& .ant-tree-checkbox-checked': {
			'& .ant-tree-checkbox-inner': {
				background: '#0F25D1 !important',
				borderColor: '#0F25D1 !important'
			}
		},
		'& .ant-tree-checkbox:hover .ant-tree-checkbox-inner': {
			borderColor: '#0F25D1 !important'
		},
		'& .ant-tree-checkbox-checked:after': {
			borderColor: '#0F25D1 !important'
		},
		'& .ant-tree-checkbox-disabled.ant-tree-checkbox-checked .ant-tree-checkbox-inner': {
			background: '#f5f5f5 !important',
    	borderColor: '#d9d9d9 !important',
		},
		'& .ant-input:hover, & .ant-input:focus, & .ant-input:active': {
			borderColor: '#0F25D1 !important',
		}
	},
	addLine: {
		display: 'flex',
		alignItems: 'center'
	},
	addBox: {
		flex: 1,
		height: '24px',
		marginLeft: '6px',
		background: '#fff'
	},
	treeInput: {
		width: '145px !important',
		height: '24px',
		margin: '0 7px !important'
	},
	treeBtn: {
		width: '70px',
		height: '24px',
		padding: '0 !important',
		background: '#0F25D1 !important',
		borderColor: '#0F25D1 !important',
		fontSize: '12px',
	}
});
export default function LabelTree(props) {
  const { data, checkIds, getCheckedKey, createLabel, isEdit } = props
  const classes = useStyles();
	const [parentId, setParentId] = useState('')
	const [newLabel, setNewLabel] = useState('')
	const [isInit, setIsInit] = useState(false)
	const [expandKeys, setExpandKeys] = useState([])
	const [selectedKeys, setSelectedKeys] = useState([])
	const [treeData, setTreeData] = useState([])

	const inputRef = useRef()
	
	const addLabel = () => {
		if (newLabel) {
			createLabel(newLabel, parentId, () => {
				if (inputRef) {
					// inputRef.current.input.value = ''
					setNewLabel('')
				}
			})
		}
	}

	const menu = (
		<ul className="ant-dropdown-menu ant-dropdown-menu-root ant-dropdown-menu-vertical ant-dropdown-menu-light" >
			<li className="ant-dropdown-menu-item ant-dropdown-menu-item-only-child" >
				<span className="ant-dropdown-menu-title-content" onClick={() => addLabel(true)}>
					 添加同级
				</span>
			</li>
			<li className="ant-dropdown-menu-item ant-dropdown-menu-item-only-child" >
				<span className="ant-dropdown-menu-title-content" onClick={() => addLabel(false)}>
					 添加子级
				</span>
			</li>
		</ul>
	);

	const getTreeData = () => {
		const loop = (list) => {
			return list.map(item => {
			const title = item.key == parentId ? (
				<div className={classes.addLine}>
					<span>{item.title}</span>
					<div className={classes.addBox}>
						<Input ref={inputRef} onChange={handleChange} size="small" className={classes.treeInput}/>
						<Button onClick={addLabel} type="primary" size="small"  icon={<PlusOutlined />} className={classes.treeBtn}>添加</Button>
						{/* <Dropdown overlay={menu} placement="bottom" arrow>
							<Button onClick={e => e.preventDefault()} type="primary" size="small"  icon={<PlusOutlined />} className={classes.treeBtn}>添加</Button>
						</Dropdown> */}
					</div>
				</div>
			) : (<span>{item.title}</span>)
				if (item.children) {
          return { 
						title, 
						key: item.key,
						disabled: item.disabled, 
						children: loop(item.children) 
					};
				}
				return {
					title,
					key: item.key,
					disabled: item.disabled
				}
			})
		}
		let newData = loop(data)
		setTreeData(newData)
	}

	const handleChange = (e) => {
		setNewLabel(e.target.value)
	}

	const onSelect = (selectedKeys, info) => {
		if (selectedKeys.length == 0) {
			selectedKeys = [info.node.key]
		}
		setSelectedKeys(selectedKeys)
	}

	const onCheck = (checkedKeys) => {
		let newKeys = checkedKeys.checked.filter(v => {
			return checkIds.indexOf(v) === -1
		})
		if (isEdit) {
			newKeys = [].concat(checkedKeys.checked)
		}
		let labelInfo = {
			title: data[0].title,
			children: data[0].children.filter(v => {
				return newKeys.indexOf(v.key) > -1
			}).map(v => {
				return v.title
			})
		}
		getCheckedKey(labelInfo)
	}

	const onExpand = (keys) => {
		setExpandKeys(keys)
	}

	const getDefaultKey = () => {
		if (data.length > 1) {
			let key = data[data.length - 1].key
			setSelectedKeys([key])
			setParentId(key)
		} else {
			let child = data[0].children
			let expandKey = data[0].key
			setExpandKeys([expandKey])
			setParentId(expandKey)
			if (child && child.length) {
				let key = child[child.length - 1].key
				setSelectedKeys([key])
			}
		}
		setIsInit(true)
	}

	useEffect(() => {
		if (!isInit) {
			getDefaultKey()
		}
	  getTreeData()
	}, [data, parentId, newLabel])

  return (
    <div className={classes.treeBox} >
			<Tree
				checkable
				checkStrictly={true}
				// selectedKeys={selectedKeys}
				expandedKeys={expandKeys}
				defaultCheckedKeys={checkIds}
				// onSelect={onSelect}
				onCheck={onCheck}
				onExpand={onExpand}
				treeData={treeData}
    	/>
    </div>
  )
}
